import React from 'react';
import {type Control} from 'react-hook-form';
import {
	AttributeContainer,
	type AttributeContainerProps,
} from './AttributeContainer';

export interface ReactHookFormAttributeContainerProps
	extends Omit<AttributeContainerProps, 'value'> {
	control: Control;
}

export const ReactHookFormAttributeContainerPrimitive = (
	{control, ...props}: ReactHookFormAttributeContainerProps,
	ref: any,
) => {
	return (
		<AttributeContainer
			ref={ref}
			readOnly={false}
			{...props}
			control={control}
		/>
	);
};

export const ReactHookFormAttributeContainer = React.forwardRef(
	ReactHookFormAttributeContainerPrimitive,
);

export default ReactHookFormAttributeContainer;
